import createBreakpoints from '@material-ui/core/styles/createBreakpoints'
import spacing from 'theme/config/spacing'

const breakpoints = createBreakpoints({})

export default {
  root: {
    padding: '2rem',
    alignItems: 'center',
  },
  action: {
    marginTop: 0
  },
  avatar: {
  },
  content: {
    [breakpoints.down('sm')]: {
      width: '100%',
      marginBottom: spacing(2)
    },
  },
  action: {
    [breakpoints.down('sm')]: {
      width: '100%'
    },
  }
};
